<template>
    <div>
        <ul class="prouctList">
            <li v-for="(item,index) in productList" :key="index">
                <ul>
                    <li class="imgs">
                        <div>
                            <img :src="item.filePath" alt />
                        </div>
                    </li>
                    <li>
                        <h3>{{item.productName}}</h3>
                        <p>静载{{item.deadLoad}}kg&nbsp;|&nbsp;动载{{item.dynamicLoad}}kg<span v-if="item.shelfLoad">&nbsp;|&nbsp;货架{{item.shelfLoad}}kg</span></p>
                        <p>{{item.productDesc}}</p>
                        <p>{{item.length}}mm*{{item.width}}mm*{{item.height}}mm</p>
                        <p>自重{{item.weight}}kg</p>
                    </li>
                    <li class="price">
                        <p >
                            <span>￥</span>
                            <span>{{item.displayUnitRental}}</span>
                            <span>/天起</span>
                        </p>
                        <div>
                            <Button type="warning" @click="checkProductDetail(item)" style="width:100px">立即租托</Button>
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
import tabs from '@/components/tabs.vue'
export default {
    components: {tabs},
    data() {
        return {
            productList: [],
            tabList: [
                { title: '联合采购', value: 'salePrice' },
                { title: '拆借租赁', value: 'rental' },
                { title: '托管共享', value: 'dailyYield' },
                { title: '绿色回收', value: 'recovery' },
            ],
            activeTab: 'salePrice',
        }
    },
    mounted() {
        this.queryProductList();
    },
    methods: {
        async queryProductList() {
            let param = {
                url: 'http://MID-CLIENT-MALL/messageService/productService/queryRentalProductList'
            }
            
            this.productList = await this.invoke(param);

            this.productList.forEach((product, index) => {
                let targetCode = product.targetModelCode;
                let param = {
                    url: 'http://CORE-TARGET/messageService/baseInfoService/queryTargetConfigurationByTargetCode',
                    body: {targetCode}
                };
                this.invoke(param).then(model => {
                    this.$set(this.productList, index, {...product, ...model});
                })
            })
        },
        checkProductDetail({productId}) {
            let routeData = this.$router.resolve({
                path: '/lease-product-details', 
                query: {productId}
            });

            window.open(routeData.href, '_blank');
        }
    }
}
</script>

<style lang="scss" scoped>
.prouctList {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #cacaca;
    border-bottom: 1px solid transparent;
    li {
        width: 100%;
        height: 200px;
        border-bottom: 1px solid #cacaca;
        cursor: pointer;
        &:hover{
            background: #fff7f2;
        }
        ul {
            display: flex;
            height: 100%;
            align-items: center;
            .imgs {
                height: 200px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                div {
                    width: 175px;

                    img {
                        width: 175px;
                    }
                }
            }
            li {
                display: flex;
                flex-direction: column;
                // align-items: center;
                justify-content: center;
            }
            .price {
                display: flex;
                flex-direction: row;
                // justify-content: center;
                align-items: center;
                div {
                    margin-left: 20px;
                }
                p {
                    width: 100px;
                    color: #ff9000;
                    span:nth-child(2) {
                        font-size: 20px;
                        font-weight: bold;
                    }
                    span:nth-child(3) {
                        color: #333;
                    }
                }
            }
        }
    }
}

</style>